const Airplane = () => {
    return (
        <svg width="20" height="25" viewBox="5 7 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.04503 10.7559L6.45904 9.34189L15.9487 11.7615L19.8372 7.87297C20.424 7.28615 21.3964 7.31115 22.0142 7.92895C22.632 8.54675 22.657 9.51912 22.0701 10.1059L18.1816 13.9944L20.6012 23.484L19.1872 24.898L15.0001 17.1759L11.1116 21.0644L11.5397 23.6136L10.4792 24.6741L8.58106 21.362L5.26896 19.4639L6.32946 18.4034L8.87862 18.8315L12.7672 14.943L5.04503 10.7559Z" fill="#81868C"></path>
        </svg>
    )
}

export default Airplane
